import template from './call-confirmation-popup.html';
import './call-confirmation-popup.scss';
const module = angular.module('doxy.videoChat.callConfirmationPopup', []);
export default module.component('callConfirmationPopup', {
  // call-confirmation-popup
  template,
  bindings: {
    text: '<',
    description: '<',
    onYes: '&',
    yesTxt: '<?',
    noTxt: '<?',
    onNo: '&',
  },
}).name;
